import React, { useEffect } from 'react';
import styles from '../../sass/favourites.module.scss';
import { Link } from 'react-router-dom';
import { IMG } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import { listFavourite, removeFavourite } from '../../redux/actions/favouriteActions';
import { toast } from 'react-toastify';
import './favourites.scss';
import ProductCard from '../../components/ProductCard';

const Favourites = () => {
  const dispatch = useDispatch();
  const { token, userDetails } = useSelector((state) => state.user);
  const { favourites, loader, errors } = useSelector((state) => state.favourites);

  // Handle different possible response structures
  let products = [];
  if (favourites) {
    if (Array.isArray(favourites)) {
      products = favourites;
    } else if (favourites.data && Array.isArray(favourites.data)) {
      // Laravel paginated response
      products = favourites.data;
    } else if (favourites.products && Array.isArray(favourites.products)) {
      products = favourites.products;
    }
  }

  useEffect(() => {
    if (userDetails?.id) {
      dispatch(listFavourite())
    }
  }, [dispatch, userDetails]);

  const handleRemoveFavourite = (productId) => {
    const isConfirmed = window.confirm('Are you sure you want to remove this product from favourites?');

    if (isConfirmed) {
      dispatch(removeFavourite(productId))
        .unwrap()
        .then(() => {
          toast.info('Product removed from favourites!');
          dispatch(listFavourite()); // Refresh the list
        })
        .catch((err) => {
          toast.error('Failed to remove product from favourites.');
          console.error('Error:', err);
        });
    }
  };

  if (loader) {
    return (
      <div className={styles.loaderContainer}>
        <span className={styles.loaderText}>Loading favourites…</span>
      </div>
    );
  }

  if (errors) {
    return (
      <section className={styles.favouritesPage}>
        <div className={styles.favouritesContainer}>
          <header className={styles.favouritesHeader}>
            <p className={styles.favouritesEyebrow}>Saved items</p>
            <h1 className={styles.favouritesTitle}>My Favourites</h1>
            <p className={styles.favouritesSubtitle}>Quick access to the products you love. Add them to cart whenever you're ready.</p>
          </header>
          <div className={styles.emptyState}>
            <img alt="Empty favourites illustration" src={IMG.cempty} />
            <p className={styles.emptyTitle}>We couldn&apos;t load your favourites</p>
            <p className={styles.emptySubtitle}>Please refresh the page or try again in a few minutes.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.favouritesPage}>
      <div className={styles.favouritesContainer}>
        <header className={styles.favouritesHeader}>
          <p className={styles.favouritesEyebrow}>Saved items</p>
          <h1 className={styles.favouritesTitle}>My Favourites</h1>
          <p className={styles.favouritesSubtitle}>Quick access to the products you love. Add them to cart whenever you&apos;re ready.</p>
        </header>

        {products.length === 0 ? (
          <div className={styles.emptyState}>
            <img alt="Empty favourites illustration" src={IMG.cempty} />
            <p className={styles.emptyTitle}>You haven&apos;t saved anything yet</p>
            <p className={styles.emptySubtitle}>
              Looks like your favourites list is waiting to be filled. Go ahead and explore{' '}
              <Link to='/search' className={styles.browseLink}>top brands</Link>.
            </p>
          </div>
        ) : (
          <div className="productGrid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} showPrice={false} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Favourites;
